import React from 'react';
import { useSelector } from 'react-redux';
import { LOADING_CIRCLE, Status } from 'common/utils/constants';
import styles from './DeviceMapStatus.module.css';

function DeviceMapStatus() {
  const status = useSelector(getDeviceMapStatus);
  const empty = useSelector(isDeviceMapEmpty);
  const polygonPending = useSelector(isMapPolygonPending);

  if (status === Status.PENDING || polygonPending) {
    return <div className={styles.progress}>{LOADING_CIRCLE}</div>;
  }

  if (status === Status.FAILURE && empty) {
    return (
      <div className={styles.error}>
        <div className={styles.errorMessage}>No Devices</div>
      </div>
    );
  }

  return null;
}

export default DeviceMapStatus;

const getDeviceMapStatus = (state) => {
  const {
    statuses,
    ui: {
      devicesPage: { activeTab }
    }
  } = state;
  const statusName = ['searchComponentFilteredDevicesV2', 'deviceMap', activeTab].join('_');

  return statuses[statusName];
};

const isDeviceMapEmpty = (state) => !state.data.deviceSets?.deviceMap?.devices?.length;

const isMapPolygonPending = (state) => {
  const { statuses } = state;

  return ['GET-User-DevicePolygons', 'POST-User-DevicePolygon', 'PUT-User-DevicePolygon'].some(
    (statusName) => statuses[statusName] === Status.PENDING
  );
};
